/**
 * Create the store with asynchronously loaded reducers
 */

import { applyMiddleware, compose, createStore } from "redux";
import { createEpicMiddleware } from "redux-observable";

import createReducers from "./module/reducers";
import createRootEpic from "./module/epics";
import resetEnhancer from "./module/enhancers/resetEnhancer";
import routerLocation from "./module/middlewares/routerLocation";

import { routerMiddleware } from "connected-react-router";

export const setupEpics = createRootEpic();
const epicMiddleware = createEpicMiddleware();

export default function configureStore(initialState = {}, history) {
  const middlewares = [
    epicMiddleware,
    routerMiddleware(history),
    routerLocation,
  ];

  const enhancers = [applyMiddleware(...middlewares), resetEnhancer];

  const composeEnhancers =
    process.env.NODE_ENV !== "production" &&
    typeof window === "object" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;

  const store = createStore(
    createReducers(history),
    initialState,
    composeEnhancers(...enhancers)
  );

  store.epic$ = setupEpics.epic$;
  store.asyncReducers = {};

  if (module.hot) {
    module.hot.accept("./module/reducers/", () => {
      const defaultReducers = createReducers.default;
      store.replaceReducer(defaultReducers(store.asyncReducers, history));
    });

    module.hot.accept("./module/epics/", () => {
      const defaultEpics = createRootEpic.default;
      epicMiddleware.replaceEpic(defaultEpics);
    });
  }
  epicMiddleware.run(setupEpics.rootEpic);

  return store;
}
